// removed by extract-text-webpack-plugin
module.exports = {"page-canvas":"ContentTemplate__page-canvas___2zeWI","navigation":"ContentTemplate__navigation___3diPJ","main":"ContentTemplate__main___2IkT5","content":"ContentTemplate__content___y5CVW","page-container":"ContentTemplate__page-container___3JCgC","page-content":"ContentTemplate__page-content___35CwF","navigation-inner":"ContentTemplate__navigation-inner___yD4S7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ContentTemplate/ContentTemplate.scss
// module id = 923
// module chunks = 0